/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { defineMessages, useIntl } from 'react-intl-next';
import { useUser } from '../../../web-client/hooks/useUser';
import { useInlineContext } from '../../../context/inline';
var AKAvatar = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/avatar');
});
var AKBadge = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/badge');
});
var AKAvatarItem = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/avatar').then(function (module) {
    return {
      default: module.AvatarItem
    };
  });
});
function Avatar(_ref) {
  var name = _ref.name,
    picture = _ref.picture;
  return jsx("div", {
    // Reduce Atlaskit padding to vertically-align with other components
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '> span': {
        paddingLeft: 0,
        backgroundColor: 'transparent',
        cursor: 'default'
      }
    })
  }, jsx(AKAvatarItem, {
    avatar: jsx(AKAvatar, {
      name: name,
      src: picture
    }),
    primaryText: name
  }));
}
function UserInline(_ref2) {
  var name = _ref2.name;
  var intl = useIntl();
  return jsx(AKBadge, {
    appearance: "primary"
  }, name || intl.formatMessage(messages.unknownUser));
}
export default function User(_ref3) {
  var accountId = _ref3.accountId,
    client = _ref3.client;
  var _useUser = useUser(accountId, client),
    picture = _useUser.picture,
    name = _useUser.name;
  var _useInlineContext = useInlineContext(),
    inline = _useInlineContext.inline;
  if (inline) {
    return jsx(UserInline, {
      name: name
    });
  }
  return jsx(Avatar, {
    name: name,
    picture: picture
  });
}
export function UserFn(_ref4) {
  var props = _ref4.props;
  var _ref5 = props,
    accountId = _ref5.accountId;
  return jsx(User, {
    accountId: accountId,
    client: undefined
  });
}

// new approach requires ApolloClient as a prop
export function makeUser(_ref6) {
  var client = _ref6.client;
  return function UserFnNext(_ref7) {
    var props = _ref7.forgeDoc.props;
    var _ref8 = props,
      accountId = _ref8.accountId;
    return jsx(User, {
      accountId: accountId,
      client: client
    });
  };
}
var messages = defineMessages({
  unknownUser: {
    id: 'confluence.user.unknown.user.message',
    defaultMessage: 'Unknown User',
    description: 'This is a fallback message that displays when a username is not known.'
  }
});